module.exports = __webpack_public_path__ + "media/images/icons/spa_invite-429fd7bd7289ff52d11217ecf176fc44.png";